declare var languagePack;
var langAcc=languagePack.account;
 export class Dictionary {
    //站点类型
    static SITE_TYPE_SHOP=1;
    static SITE_TYPE_SHOP_PRO=2;
    static SITE_TYPE_FACTORY=3;
    static SITE_TYPE_FACTORY_PRO=4;
    static SITE_TYPE_MAIN_SITE=5;
    static SITE_TYPE_CUSTOM_SITE=6;
    static SITE_TYPE_MALL=7;  //商城
    static SITE_TYPE_SHOP_ENHANCE=8; //门店加强版
    static SITE_TYPE_FULL=9; //全功能版

    //状态
    static STATUS_SUCCESS = 1000;
    static STATUS_FAILED = 1001;
    static STATUS_INFO = 1002;
    static STATUS_REDIRECT = 1005;
    static STATUS_HTML = 1006;
    static STATUS_INVALID_PARAM = 1011;
    static STATUS_NOT_LOGIN=1099;


    //订单类型
    static ORDER_TYPE_ORDER=0;//订单类型
    static ORDER_TYPE_SUB_ORDER=1;//子订单类型
    //订单状态
    static ORDER_STATUS_NEWORDER = 1;
    static ORDER_STATUS_PAID = 2;
    static ORDER_STATUS_PRODUCE=21;
    static ORDER_STATUS_SENT = 3;
    static ORDER_STATUS_RECEIVED = 4;
    static ORDER_STATUS_SUCCESS = 5;
    static ORDER_STATUS_CLOSED = 9;
    static ORDER_STATUS_REFUND_SUCCESS=20;

    static GOODS_STATUS_NOT_PRODUCE=1;//未生产
    static GOODS_STATUS_IN_PRODUCE=2; //生产中

    //订单和子订单的refund_status的值
    static ORDER_REFUND_STATUS_EMPTY = 0;//无退款
    static ORDER_REFUND_STATUS_APPLY = 1;//有退款申请
    static REFUND_STATUS_PARTIAL=20;
   // static ORDER_REFUND_STATUS_RESOLEVED = 2;//有退款(已经处理完成)
   static ORDER_REFUND_STATUS_SUCCESS=1000;//退款成功 --用于子订单或者只有一个子订单的订单
   static ORDER_REFUND_STATUS_FAIL=1001;//退款失败 --用于子订单或者只有一个子订单的订单
   static REFUND_STATUS_SUBORDER_REFUNDED=30;//有退款成功的子订单 --用于订单


    //支付方式
    static PAY_MODE_ONLINE = 1; //线上
    static PAY_MODE_OFFLINE = 2; //线下
    static PAY_MODE_MIXED = 3; //混合


    //支付平台
    static PAYMENT_PLATFORM_ALIPAY = 1;
    static PAYMENT_PLATFORM_WECHATPAY = 2;
    static PAYMENT_PLATFORM_LIANTUOPAY = 3;
    static PAYMENT_PLATFORM_USER_ACCOUNT = 6;
    static PAYMENT_PLATFORM_STRIPE=7;
    static PAYMENT_PLATFORM_OTHERS = 9;
    static PAYMENT_PLATFORM_MIXED = 99;

    //通用交易状态
    static TRADE_STATUS_APPLY = 0;//申请
    static TRADE_STATUS_ACCEPT = 1;//处理中
    static TRADE_STATUS_SUCCESS = 1000;//成功
    static TRADE_STATUS_FAIL = 1001;//失败

    //付款状态：

    static PAY_STATUS_EMPTY = 0;//无支付
    static PAY_STATUS_APPLY = 1;//申请支付
    static PAY_STATUS_OFFLINE_NOT_CONFIRMED = 2;//线下付款未确认
    static PAY_STATUS_IN_PROGRESS = 11;//平台付款处理中
    static PAY_STATUS_SUCCESS = 1000;//付款成功 ，线下付款确认成功
    static PAY_STATUS_FAIL = 1001;//付款失败，线下付款失败

    //退款记录的refund_status的退款状态
    static REFUND_STATUS_EMPTY = 0;//无退款
    static REFUND_STATUS_APPLY = 1;//申请退款
    static REFUND_STATUS_ACCEPT = 2;//同意退款
    static REFUND_STATUS_REFUSE = 3;//拒绝退款
    static REFUND_STATUS_IN_PROGRESS = 11;//退款中
    static REFUND_STATUS_SUCCESS = 1000;//退款成功
    static REFUND_STATUS_FAIL = 1001;//
   // static REFUND_STATUS_SUBORDER_REFUNDED=30;//有退款成功的子订单

    //账户类型
    static USER_ACCOUNT_DATA_TYPE_BALANCE = 1;
    static USER_ACCOUNT_DATA_TYPE_EARNEST_MONEY = 2;

    //保证金状态
    static USER_ACCOUNT_EARNEST_MONEY_STATUS_FREEZE = 1;
    static USER_ACCOUNT_EARNEST_MONEY_STATUS_UNFREEZE = 2;

    //账户明细记录类型
    static USER_ACCOUNT_ACTION_DETAIL_TYPE_DEPOSIT = 1;
    static USER_ACCOUNT_ACTION_DETAIL_TYPE_ADD = 2;
    static USER_ACCOUNT_ACTION_DETAIL_TYPE_CONSUME = 3;
    static USER_ACCOUNT_ACTION_DETAIL_TYPE_WITHDRAW = 4;
    static USER_ACCOUNT_ACTION_DETAIL_TYPE_TRANSFEROUT = 5;
    static USER_ACCOUNT_ACTION_DETAIL_TYPE_TRANSFERIN = 6;
    static USER_ACCOUNT_ACTION_DETAIL_TYPE_REFUND = 7;
    static USER_ACCOUNT_ACTION_DETAIL_TYPE_COMMISSION = 20;

    //提现记录状态
    static USER_ACCOUNT_WITHDRAW_APPLYFOR=1;
    static USER_ACCOUNT_WITHDRAW_TRANSFERRED=2;
    static USER_ACCOUNT_WITHDRAW_CONFIRMED=3;
    static USER_ACCOUNT_WITHDRAW_REFUSED=5;

    //用户账户操作者类型
    static OPERATOR_TYPE_FRONTEND_USER = 1;
    static OPERATOR_TYPE_BACKEND_USER = 2;
    
    //收支类型
    static INCOME_EXPENSE_TYPE_INCOME=1;
    static INCOME_EXPENSE_TYPE_EXPENSE=2;
    static INCOME_EXPENSE_TYPE_BAD=3;

    //特别类型
    static PURPOSE_SPECIAL_TYPE_COMMON=0;
    static PURPOSE_SPECIAL_TYPE_GOODS=1;

    static userLevel={
        0:"普通用户",1:"1星用户",2:"2星用户",3:"3星用户",4:"4星用户",5:"5星用户",6:"合作代理",10:"内部人员"
    }

    //数据字典常数
    static ValueTypeStringOrNumber=1;
    static ValueTypeArray=2; 
    static ValueCustomType=3;
    static SrcOnlyFromTemp=1;
    static SrcFromTempAndCustom=2;

    //短信模板类型
    static SMS_TEMP_TYPE_VERIFY_CODE=1;

    // 报价项目选项
    static PROJECT_OPTIONS_NONPUBLIC=1;
    static PROJECT_OPTIONS_LOCKED=2;
    static PROJECT_OPTIONS_MUST_UPLOAD_FILE=3;
    static PROJECT_OPTIONS_NOT_UPLOAD_FILE=5;
}

export class Resource {
    static projectOptions = [
        {value:Dictionary.PROJECT_OPTIONS_NONPUBLIC ,text:"非公开"},
        {value:Dictionary.PROJECT_OPTIONS_LOCKED,text:"锁定修改"},
        {value:Dictionary.PROJECT_OPTIONS_MUST_UPLOAD_FILE,text:"必须上传文件"},
        {value:Dictionary.PROJECT_OPTIONS_NOT_UPLOAD_FILE,text:"不上传文件"}
    ];

    
    static smsTemplateSource = {
        [Dictionary.SMS_TEMP_TYPE_VERIFY_CODE]: '验证码'
    }
    static orderStatusTitles = {
        [Dictionary.ORDER_STATUS_NEWORDER]: '待付款',
        [Dictionary.ORDER_STATUS_PRODUCE]: '生产中', 
        [Dictionary.ORDER_STATUS_PAID]: '待发货',
        [Dictionary.ORDER_STATUS_SENT]: '待收货',
        [Dictionary.ORDER_STATUS_RECEIVED]: '待评价',
        [Dictionary.ORDER_STATUS_SUCCESS]: '已完成',
        [Dictionary.ORDER_STATUS_CLOSED]: '已关闭',
        [Dictionary.ORDER_STATUS_REFUND_SUCCESS]: '退款成功'
    }
    static orderGoodsStatusTitles = {
        [Dictionary.GOODS_STATUS_NOT_PRODUCE]: '待生产',
        [Dictionary.GOODS_STATUS_IN_PRODUCE]: '生产中', 
    }

    static orderRefundStatusTitles = {
        [Dictionary.ORDER_REFUND_STATUS_EMPTY]:'无退款',
        [Dictionary.ORDER_REFUND_STATUS_APPLY]: '有退款申请',
        [Dictionary.REFUND_STATUS_PARTIAL]:'部分退款',
        [Dictionary.ORDER_REFUND_STATUS_SUCCESS]:'退款成功',
        [Dictionary.ORDER_REFUND_STATUS_FAIL]: '退款失败',
        [Dictionary.REFUND_STATUS_SUBORDER_REFUNDED]:'有退款',
    }
    static PAY_MODE_TITLE = {
        [Dictionary.PAY_MODE_ONLINE]: '线上',
        [Dictionary.PAY_MODE_OFFLINE]: '线下',
        [Dictionary.PAY_MODE_MIXED]: '混合'
    }
    static PAYMENT_PLATFORM_TITLE = {
        [Dictionary.PAYMENT_PLATFORM_ALIPAY]: '支付宝',
        [Dictionary.PAYMENT_PLATFORM_WECHATPAY]: '微信',
        [Dictionary.PAYMENT_PLATFORM_LIANTUOPAY]: '聚合',
        [Dictionary.PAYMENT_PLATFORM_USER_ACCOUNT]: '账户余额',
         [Dictionary.PAYMENT_PLATFORM_STRIPE]: 'stripe',
        [Dictionary.PAYMENT_PLATFORM_OTHERS]: '其他'
    }
    static statusTitles = {
        [Dictionary.TRADE_STATUS_APPLY]: '申请', [Dictionary.TRADE_STATUS_ACCEPT]: '处理中', [Dictionary.TRADE_STATUS_SUCCESS]: '付款成功', [Dictionary.TRADE_STATUS_FAIL]: '付款失败'

    };

    static payStatusTitles = {
        [Dictionary.PAY_STATUS_EMPTY]: '无付款',
        [Dictionary.PAY_STATUS_APPLY]: '申请付款', 
        [Dictionary.PAY_STATUS_OFFLINE_NOT_CONFIRMED]: '线下付款待确认',
        [Dictionary.PAY_STATUS_IN_PROGRESS]: '平台处理中', 
        [Dictionary.PAY_STATUS_SUCCESS]: '付款成功', 
        [Dictionary.PAY_STATUS_FAIL]: '付款失败'

    };



    static refundStatusTitles = {
        [Dictionary.REFUND_STATUS_EMPTY]: "无退款",
        [Dictionary.REFUND_STATUS_APPLY]: "申请退款",
        [Dictionary.REFUND_STATUS_ACCEPT]: "同意退款",
        [Dictionary.REFUND_STATUS_REFUSE]: "拒绝退款",
        [Dictionary.REFUND_STATUS_IN_PROGRESS]: "退款中",
        [Dictionary.REFUND_STATUS_SUCCESS]: "退款成功",
        [Dictionary.REFUND_STATUS_FAIL]: "退款失败",
        [Dictionary.REFUND_STATUS_SUBORDER_REFUNDED]:"有退款"
    };
    static userAccountDetailDataTypeTitles = {
        [Dictionary.USER_ACCOUNT_DATA_TYPE_BALANCE]: langAcc.balance,
        [Dictionary.USER_ACCOUNT_DATA_TYPE_EARNEST_MONEY]: langAcc.margin
    }
    static userAccountDetailActionTypeTitles = {
        [Dictionary.USER_ACCOUNT_ACTION_DETAIL_TYPE_DEPOSIT]:langAcc.recharge,
        [Dictionary.USER_ACCOUNT_ACTION_DETAIL_TYPE_ADD]:langAcc.admin_add_funds,
        [Dictionary.USER_ACCOUNT_ACTION_DETAIL_TYPE_CONSUME] :langAcc.consumption,
        [Dictionary.USER_ACCOUNT_ACTION_DETAIL_TYPE_WITHDRAW]: langAcc.withdraw,
        [Dictionary.USER_ACCOUNT_ACTION_DETAIL_TYPE_TRANSFEROUT]: langAcc.transfer_out,
        [Dictionary.USER_ACCOUNT_ACTION_DETAIL_TYPE_TRANSFERIN]:langAcc.transfer_in,
        [Dictionary.USER_ACCOUNT_ACTION_DETAIL_TYPE_REFUND]:langAcc.refund,
        [Dictionary.USER_ACCOUNT_ACTION_DETAIL_TYPE_COMMISSION]:langAcc.commission,
    }

    static userAccountEarnestMoneyStatusTitles = {
        [Dictionary.USER_ACCOUNT_EARNEST_MONEY_STATUS_FREEZE]: langAcc.freeze,
        [Dictionary.USER_ACCOUNT_EARNEST_MONEY_STATUS_UNFREEZE]: langAcc.unfreeze
    }
    static userAccountOperatorTypeTitles = {
        [Dictionary.OPERATOR_TYPE_BACKEND_USER]: "后台用户",
        [Dictionary.OPERATOR_TYPE_FRONTEND_USER]: "前台用户"
    }

    static withdrawStatusTitles = {
        [Dictionary.USER_ACCOUNT_WITHDRAW_APPLYFOR]: "申请提现",
        [Dictionary.USER_ACCOUNT_WITHDRAW_TRANSFERRED]: "已转帐",
        [Dictionary.USER_ACCOUNT_WITHDRAW_CONFIRMED]: "已确认",
        [Dictionary.USER_ACCOUNT_WITHDRAW_REFUSED]:"已拒绝"
    }

    static userLevelSource=[
        {value:0,text:"普通用户"},{value:1,text:"1星用户"},{value:2,text:"2星用户"},{value:3,text:"3星用户"},{value:4,text:"4星用户"},{value:5,text:"5星用户"},{value:6,text:"合作代理"},{value:10,text:"内部人员"}
    ]

    static IncomeExpenseTypeSource=[
        {value:Dictionary.INCOME_EXPENSE_TYPE_INCOME,text:'收入'},
        {value:Dictionary.INCOME_EXPENSE_TYPE_EXPENSE,text:'支出'},
        {value:Dictionary.INCOME_EXPENSE_TYPE_BAD,text:'坏账'}
    ]

    static PurposeSpecialTypeSource=[
        {value:Dictionary.PURPOSE_SPECIAL_TYPE_COMMON,text:'普通'},
        {value:Dictionary.PURPOSE_SPECIAL_TYPE_GOODS,text:'货款'}
    ]

    static dictionaryValueTypeTitles = {
        [Dictionary.ValueTypeStringOrNumber]: "数值/字符串",
        [Dictionary.ValueTypeArray]: "数组",
        [Dictionary.ValueCustomType]: "预定义"
    }
}